import React from "react";
import { FaBed, FaBuilding, FaCoffee, FaHome, FaHotel, FaUmbrellaBeach } from "react-icons/fa";
import { FiCheck } from "react-icons/fi";

const TYPES = [
  { name: "Hotel", icon: <FaHotel />, hint: "Rooms, front desk, restaurant" },
  { name: "Guest House", icon: <FaHome />, hint: "Smaller, owner-run stays" },
  { name: "Resort", icon: <FaUmbrellaBeach />, hint: "Leisure, activities, grounds" },
  { name: "Bed & Breakfast", icon: <FaCoffee />, hint: "Rooms with breakfast" },
  { name: "Hostel", icon: <FaBed />, hint: "Dorms and shared spaces" },
  { name: "Apartment", icon: <FaBuilding />, hint: "Self-catering units" },
];

export default function PropertyTypeStep({ value, onChange, error }) {
  return (
    <div>
      <h2 className="reg-title">What type of property are you registering?</h2>
      <p className="reg-sub">This sets up the right wording and defaults for you. You can change details later.</p>

      <div className="type-grid" role="radiogroup" aria-label="Property type">
        {TYPES.map((t) => {
          const on = value === t.name;
          return (
            <button
              key={t.name}
              type="button"
              role="radio"
              aria-checked={on}
              className={`type-tile ${on ? "is-selected" : ""}`}
              onClick={() => onChange(t.name)}
            >
              <span className="type-icon">{t.icon}</span>
              <span className="type-name">{t.name}</span>
              <span className="type-hint">{t.hint}</span>
              {on && (
                <span className="type-check" aria-hidden="true">
                  <FiCheck />
                </span>
              )}
            </button>
          );
        })}
      </div>

      {error && (
        <p className="auth-error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
